import * as HttpService from 'services/http.service';
import {
  GET_COLLECTION_BY_SLUG,
  GET_PRICE_RANGE_BY_SLUG,
  GET_PUBLISHED_COLLECTIONS
} from 'services/url.service';

export const getPublishedCollections = (skip = 0, limit = 10) =>
  HttpService.getWithoutAuth(GET_PUBLISHED_COLLECTIONS(skip, limit));

export const getCollectionBySlug = (collectionSlug) =>
  HttpService.getWithoutAuth(GET_COLLECTION_BY_SLUG(collectionSlug));

export const getCollectionPriceRangeBySlug = (payload) =>
  HttpService.postWithoutAuth(GET_PRICE_RANGE_BY_SLUG, payload);
